import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

const ReplacePopup = ({ open, onClose, process, postId, setPostId }) => {

    const handleClose = () =>{
        setPostId("");
        onClose();
    }
  
  
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Replace </DialogTitle>
      <DialogContent>
            <TextField
                label="Enter Post Id"
                value={postId}
                onChange={(e)=>{setPostId(e.target.value)}}
                fullWidth
                sx={{ mb: 2 }}
            />
            <Button
              variant="contained"
              onClick={process}
            >
              Confirm 
            </Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReplacePopup;
